module.exports = __webpack_public_path__ + "a6d1a07fec4b51fd5f16fc9f70be3f2a.MP3";